"use strict";
/**
 * SITPV (SENASICA) emission, additional info and monthly report — API contracts. GH535 · Steps 12–14.
 *
 * Emission is **preview → a person sees the PDF → emit**: the preview returns the sha256 of the exact body
 * sent to the portal, and emit requires it back (and refuses if the body would differ).
 */
Object.defineProperty(exports, "__esModule", { value: true });
